import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
});

export const itemCategoriesApi = {
  getCategories: async () => {
    const response = await axios.get(`${API_URL}/api/admin/item-categories`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  getCategoryById: async (id: string) => {
    const response = await axios.get(`${API_URL}/api/admin/item-categories/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  createCategory: async (data: any) => {
    const response = await axios.post(`${API_URL}/api/admin/item-categories`, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  updateCategory: async (id: string, data: any) => {
    const response = await axios.put(`${API_URL}/api/admin/item-categories/${id}`, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  deleteCategory: async (id: string) => {
    const response = await axios.delete(`${API_URL}/api/admin/item-categories/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
};
